class Emitter {
    delegate;
    constructor() {
        this.delegate = document.createDocumentFragment();
        [
            //'addEventListener',
            'dispatchEvent',
            'removeEventListener'
        ].forEach(f =>
            this[f] = (...xs) => this.delegate[f](...xs)
        )
    }

    addEventListener(...xs) {
        //console.log('addEventListener with ', ...xs);
        this.delegate.addEventListener(...xs);
    }
}

export default class WidgetMarketSettingsClass extends Emitter {}
